import { Pipe, PipeTransform } from '@angular/core';
import { ReportData } from 'src/models/reportData';

@Pipe({
    name: 'filterReportDataByTitle',
    pure: false
})
export class FilterReportDataByTitle implements PipeTransform {
    transform(items: ReportData[], title: string): any {
        return title ? items.filter(item =>
            item.Title?.toLowerCase().indexOf(title.toLowerCase()) > -1) : items;
    }
}
